module.exports = __webpack_public_path__ + "assets/img/DS-master (11).49bf4118.jpg";